import StepOne from "@/components/dashboard/pay/StepOne";

const PayStep1 = () => <StepOne />;

export default PayStep1;
